import type { DeviceGroupAttribute } from '@ipfabric/utils';
import type { GraphCommandFactory } from '../model/GraphCommandContext';

interface SaveNetworkViewerGroupBy {
  groupBy: DeviceGroupAttribute | null;
}

export const saveNetworkViewerGroupBy: GraphCommandFactory<
  SaveNetworkViewerGroupBy
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    draft.networkViewer.groupBy = command.groupBy;
  });
};
